<template>
	<section class="ui-input select" :id="uniqueID" @mouseleave="closeOptions($event)" :class="size">
		<span v-if="label" class="label">
			<span v-html="label"></span>
			<span class="label-required" v-if="required">*</span>
		</span>

		<section :class="status" ref="field" class="field" @click="clearError">
			<section class="selecteds">
				<span v-for="(item, index) in selecteds" :key="index" @click="removeItem(item)">{{ item }}</span>
				<input v-model="s"
					:disabled="load ? true : false"
					type="text"
					class="input"
					ref="input"
                    autocomplete="off"
					@focus="openOptions($event)" />
			</section>
			<div class="load-icon" v-if="load"></div>
		</section>

		<!-- default -->
		<section class="options" v-if="typeDefault" v-show="showOptions">
			<div class="group">
				<ul>
					<li v-for="(item, index) in filter"
						:key="index"
						:ref="'option-' + index"
						:tabindex="index"
						@click="selectItem(index, item)">
						{{ item }}
					</li>
				</ul>
				<div class="no-result" v-if="!filter.length">Nenhuma opção disponível para seleção</div>
			</div>
		</section>

		<!-- group -->
		<section class="options option-list-" v-if="typeGroup" v-show="showOptions">
			<div class="group" v-for="(group, index) in groupNames" :key="index">
				<h2>{{ group }}</h2>
				<ul>
					<li v-for="(item, indexItem) in labels[group]"
						:key="indexItem"
						@click="selectItem(indexItem, item, group)">
						{{ item }}
					</li>
				</ul>
				<div class="no-result" v-if="!labels[group].length">Nenhuma opção disponível para seleção</div>
			</div>
		</section>
	</section>
</template>
<script>
	import { alertMixin } from '@/mixins'
	export default {
		components: {},
		props: {
			options: {
				type: Array,
				required: false,
			},
			status: {
				type: String,
				required: false,
			},
			limit: {
				type: Number,
				required: false,
			},
			removeSelectedItem: {
				type: Boolean,
				required: false,
			},
			value: {},
			label: {
				type: String,
				required: false,
			},
			/**
			 * Utilize para alterar o tamanho do input
			 */
			size: {
				type: String,
				required: false,
				default: 'md',
			},
			load: {
				type: Boolean,
				required: false,
			},
			/**
			 * define o input como required em html5 e aplica o operador '*' na label
			 */
			required: {
				type: Boolean,
				required: false,
				default: false,
			},
		},
		mixins: [alertMixin],
		computed: {
			typeDefault() {
				return this.selectType === 'default' ? true : false
			},
			typeGroup() {
				return this.selectType === 'group' ? true : false
			},
			filter() {
				return this.labels
					.filter((item) => {
						return String(item).indexOf(this.s) > -1
					})
					.sort((a, b) => {
						return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })
					})
			},
			uniqueID() {
				return 'ui-multiple-select-' + this._uid
			},
		},
		data() {
			return {
				id: null,
				s: '',
				selectType: null,
				showOptions: false,
				labels: [],
				values: [],
				labelsCopy: [],
				valuesCopy: [],
				selecteds: [],
				selectedsValues: [],
				groupNames: [],
				allGroupsValue: [],
				allGroupsLabels: [],
			}
		},
		watch: {
			options() {
				this.labels = []
				this.values = []
				this.selecteds = []
				this.selectedsValues = []
				this.groupNames = []
				this.allGroupsValue = []
				this.allGroupsLabels = []
				this.prepareOptions()
				this.loadValues()
			},
		},
		methods: {
			clearError() {
				this.$refs.field.classList.remove('error')
			},
			prepareOptions() {
				this.selecteds = []
				if (this.options.length && this.options[0].title !== undefined) {
					this.selectType = 'group'
					for (let index in this.options) {
						const groupName = this.options[index].title
						this.groupNames.push(groupName)
						const items = this.options[index].items
						this.labels[groupName] = []
						this.values[groupName] = []
						for (let index in items) {
							this.labels[groupName].push(items[index].label)
							this.values[groupName].push(items[index].value)
							this.allGroupsLabels.push(items[index].label)
							this.allGroupsValue.push(items[index].value)
						}
					}
				} else if (this.options.length && this.options[0].label !== undefined) {
					this.selectType = 'default'
					for (const index in this.options) {
						this.labels.push(this.options[index]['label'])
						this.values.push(this.options[index]['value'])
					}
					this.labelsCopy = this.labels.slice()
					this.valuesCopy = this.values.slice()
				} else {
					this.selectType = 'default'
					for (const index in this.options) {
						this.labels.push(this.options[index])
						this.values.push(this.options[index])
					}
					this.labelsCopy = this.labels.slice()
					this.valuesCopy = this.values.slice()
				}
			},
			onChange() {
				this.$emit('input', this.selected)
				this.sendValue()
			},
			sendValue() {
				if (this.limit === 1) {
					this.$emit('input', this.selectedsValues[0])
				} else {
					this.$emit('input', this.selectedsValues)
				}
			},
			getValueGroup(index, group) {
				return this.values[group][index]
			},
			openOptions(e) {
				if (this.limit === this.selecteds.length) {
					this.$mx_alertError(`Você pode selecionar apenas ${this.limit > 1 ? this.limit + ' opções' : this.limit + ' opção'} para este campo!`)
					return false
				}
				this.showOptions = true
				e.target.closest('.field').classList.add('focus')
			},
			closeOptions(e) {
				this.showOptions = false
				e.target.querySelector('.field').classList.remove('focus')
				this.$refs.input.blur()
			},
			sortOptions() {
				this.labels.sort()
				this.values.sort()
			},
			sortOptionsGroup(groupName) {
				this.labels[groupName].sort()
				this.values[groupName].sort()
			},
			optionAdd(item) {
				this.labels.unshift(item)
				this.values.unshift(this.findValue(item))
			},
			optionDelete(item) {
				let index = this.labels.indexOf(item)
				this.$delete(this.labels, index)
				this.$delete(this.values, index)
			},
			optionGroupAdd(group, label) {
				this.labels[group].unshift(label)
				this.values[group].unshift(this.findValueGroup(label))
			},
			optionGroupDelete(group, item) {
				const index = this.labels[group].indexOf(item)
				this.$delete(this.labels[group], index)
				this.$delete(this.values[group], index)
			},
			addSeletedItem(label, value) {
				this.selecteds.push(label)
				this.selectedsValues.push(value)
			},
			findValue(label) {
				const index = this.labelsCopy.indexOf(label)
				return this.valuesCopy[index]
			},
			findLabel(value) {
				const index = this.valuesCopy.indexOf(value)
				return this.labelsCopy[index]
			},
			findValueGroup(label) {
				const index = this.allGroupsLabels.indexOf(label)
				return this.allGroupsValue[index]
			},
			findLabelGroup(value) {
				const index = this.allGroupsValue.indexOf(value)
				return this.allGroupsLabels[index]
			},
			findGroupName(value, key = 'value') {
				for (let collection of this.options) {
					let index = collection.items.findIndex((item) => item[key] === value)
					if (index >= 0) return collection.title
				}
			},
			selectItem(index, item, group = null) {
				this.showOptions = false
				if (group) {
					if (this.selectedsValues.includes(this.findValueGroup(item))) return false
					this.selecteds = [...this.selecteds, this.labels[group][index]]
					this.selectedsValues = [...this.selectedsValues, this.values[group][index]]
					this.sendValue()
					if (!this.removeSelectedItem) return false
					this.optionGroupDelete(group, item)
				} else {
					if (this.selectedsValues.includes(this.findValue(item))) return false
					this.selecteds = [...this.selecteds, this.filter[index]]
					this.selectedsValues = [...this.selectedsValues, this.filter[index]]
					this.sendValue()
					if (!this.removeSelectedItem) return false
					this.optionDelete(item)
				}
			},
			removeItem(label) {
				let index = this.selecteds.indexOf(label)
				this.$delete(this.selecteds, index)
				if (this.selectType === 'group') {
					const value = this.findValueGroup(label)
					const group = this.findGroupName(value)
					this.selectedsValues = this.selectedsValues.filter((i) => i !== value)
					this.sendValue()
					if (!this.removeSelectedItem) return false
					this.optionGroupAdd(group, label)
				} else {
					this.selectedsValues = this.selectedsValues.filter((i) => i !== this.findValue(label))
					this.sendValue()
					if (!this.removeSelectedItem) return false
					this.optionAdd(label)
				}
			},
			loadValues() {
				if (!this.value) return false

				if (this.options.length && this.options[0].title !== undefined) {
					for (const [index, value] of this.value.entries()) {
						const label = this.findLabelGroup(value)
						if (!label) {
							this.value.slice(index, 1)
							continue
						}

						this.addSeletedItem(label, value)
						this.optionGroupDelete(this.findGroupName(value), label)
						this.sendValue()
					}
				} else if (this.options.length && this.options[0].label !== undefined) {
					for (const [index, value] of this.value.entries()) {
						const label = this.findLabel(value)
						if (!label) {
							this.value.slice(index, 1)
							continue
						}

						this.addSeletedItem(label, value)
						this.optionDelete(label)
						this.sendValue()
					}
				} else {
					for (const [index, label] of this.value.entries()) {
						const value = this.findValue(label)
						if (!value) {
							this.value.slice(index, 1)
							continue
						}

						this.addSeletedItem(label, value)
						this.optionDelete(this.findLabel(label))
						this.sendValue()
					}
				}
			},
		},
		mounted() {
			this.prepareOptions()
			this.loadValues()
		},
		activated() {
			console.log('activated')
		},
	}
</script>
<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
